module.exports = __webpack_public_path__ + "static/media/tessellana_veyseli_BD_003_APA.d511721d.mp3";